import { prefix } from './actions';
import { IRootState } from '../reducer';

export const isAnyModalOpen = (state: IRootState) => state[prefix].isAnyModalOpen;